export const environment = {
  clientId: '14f6579c-ac6c-470f-8dd4-2fd0ee6d257e',
  tenantId: '707118c9-65c0-45b3-a435-33efe37cf0cc',
  authority: 'https://login.microsoftonline.com/707118c9-65c0-45b3-a435-33efe37cf0cc',
  redirectUri: 'https://dma.citiustech.com/',
  postLogoutRedirectUri: 'https://dma.citiustech.com/',
  graphUrl: 'https://graph.microsoft.com/v1.0/me',
  apiUrl: 'https://dma.citiustech.com/',
  production: true,
  apiScope: 'api://7300b0fb-ec72-4e3b-a175-98a5202230ed/access_as_user'
};
